<template>
  <div class="button-container" :style="containerStyle">
    <v-btn
      block
      :type="type"
      :href="href"
      :color="colorProps"
      :outlined="outlined"
      :rounded="rounded"
      :to="to"
      depressed
      :dark="dark"
      :target="target"
      class="button-container-button"
      :style="{ fontSize: fontSize }"
      height="100%"
      @click="$emit('click', $event)"
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: undefined
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    to: {
      type: String,
      default: undefined
    },
    href: {
      type: String,
      default: undefined
    },
    target: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '28px'
    },
    fontSize: {
      type: String,
      default: '12px'
    }
  },
  computed: {
    containerStyle() {
      return {
        pointerEvents: this.disabled ? 'none' : undefined,
        height: this.height
      }
    },
    colorProps() {
      // const colors = ['primary', 'accent', '#EF94BD']
      // if (!colors.includes(this.color)) {
      //   throw new Error(`想定しないcolorです。${this.color}`)
      // }
      if (this.disabled) {
        return 'rgba(0, 0, 0, 0.12)'
      }

      return this.color
    },
    dark() {
      if (this.disabled) {
        return true
      }
      // 薄いピンク
      if (this.color === '#EF94BD') {
        return true
      }
      // ピンク
      if (this.color === '#F576A3') {
        return true
      }
      // 濃いピンク
      if (this.color === '#E85198') {
        return true
      }
      // オレンジ
      if (this.color === '#E99F38') {
        return !this.disabled
      }
      // 濃いピンク2
      if (this.color === '#e1329d') {
        return !this.disabled
      }
      // 赤っぽいピンク
      if (this.color === '#FF3860') {
        return !this.disabled
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
.button-container {
  .button-container-button::v-deep {
    padding: 0 !important;
    .v-btn__content {
      font-weight: 600;
    }
  }
}
</style>
